import { create } from "zustand";

export type IFilterFields = {
  name: string;
  email: string;

};

type FiltersState = {
  filtersData: IFilterFields;
  setFiltersData: (filters: IFilterFields) => void;
  clearFilters: () => void;
};

const initalFilters: IFilterFields = {
  name: "",
  email: "",
};

export const useFilterStore = create<FiltersState>((set) => ({
  filtersData: initalFilters,
  setFiltersData: (filters) => set({ filtersData: filters }),
  clearFilters: () => set({ filtersData: initalFilters }),
}));
